import { Button, Container, Dropdown, Form, Modal, Nav, Table } from 'react-bootstrap';
import {
    faEllipsisVertical,
    faClone,
    faTrash,
    faCancel,
    faMailForward,
    faPhone,
    faEdit,
    faShare
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableSkeleton } from '../../../Utils/skeletonLoader/TableSkeleton';
import { useLocation, useNavigate } from 'react-router-dom';
import nodata from "../../../Utils/assets/img/leads_no_data_found.png";
import { useState } from 'react';
import { DeleteRequest, PostRequest, PutRequest } from '../../../Utils/hooks/ApiHandler';
import { toast } from 'sonner';
import useLocalStorageState from 'use-local-storage-state';
import DeleteModal from '../../DeleteModal';
import { formatDate, maskContactNumber, navigateToCrmDetail, sharePdf } from '../../../Utils/helpers/commonhelper';
import { Pagination } from './../../../CommonComponents/Pagination';
import { TableWrapper } from '../../../CommonComponents/TableWrapper';
import { IconPhone } from '@tabler/icons-react';
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials';
import { baseURL } from '../../../Utils/constants/constant';
export const QuotationListing = ({
    tempFilterData,
    allQuotation,
    limit,
    setLimit,
    columns,
    activeOffset,
    setActiveOffset,
    quotationData,
    fetchQuotation,
    isLoading,
    isMyApproval,
    total_count
}) => {

    // getting essentials for apis
    const { customer, setCustomer, headers, extras, navigate, customerId: customer_id, loginUserId, userType } = useGetEssentials()
    const location = useLocation()

    // rbac permission object
    const [PERMISSION, _] = useLocalStorageState('permission')
    // quotation permission grant
    const quotationGrant = PERMISSION?.quotation

    const [openRow, setOpenRow] = useState(null);
    const [departmentToDelete, setDepartmentToDelete] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [toCancelQuotation, setToCancelQuotation] = useState();
    const [rejectReason, setRejectReason] = useState("");

    const dataToDisplay = tempFilterData !== null ? tempFilterData?.data : allQuotation;

    const hasDataToDisplay = dataToDisplay?.length > 0;

    // pagecount for pagination
    // const pageCount = Math.ceil(quotationData?.total_count / limit);
    const isFiltered = tempFilterData !== null;
    // state for pagination to render correctly at bottom
    const currPageItems = dataToDisplay?.length;

    const pageCount = Math.ceil(
        (isFiltered
            ? (tempFilterData?.total_count || 0)
            : (total_count || 0)
        ) / limit
    );

    const totalItems = isFiltered
        ? (tempFilterData?.total_count || 0)
        : (total_count || 0);

    const displayStartItem = totalItems === 0
        ? 0
        : activeOffset * limit + 1;

    const displayEndItem = totalItems === 0
        ? 0
        : Math.min(activeOffset * limit + limit, totalItems);

    const handleCloseModal = () => {
        setShowModal(false);
        setRejectReason("");
        setLoading(false);
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const payload = {
                quotation_id: toCancelQuotation,
                customer_id: customer_id,
                canceletion_reason: rejectReason,
                user_login_id: loginUserId,
            };
            const res = await PutRequest(
                `quotation/cancelQuotation`,
                payload,
                { headers },
                extras
            );

            if (!res || res.status === "fail") {
                return toast.error(res.message || "something went wrong");
            }
            if (res.status === "success") {
                toast.success(res.message);
                setToCancelQuotation();
                setRejectReason("");

                await fetchQuotation();
                setShowModal(false);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowModal(false);
            setLoading(false);
            fetchQuotation();
        }
    };

    // Handle page change from react-paginate
    const handlePageChange = (selectedItem) => {
        setActiveOffset(selectedItem.selected);
    };


    // Trigger delete modal
    const onDelete = (id) => {
        setDepartmentToDelete(id);
        setShowDeleteModal(true);
    };

    const handleCancelQuotation = (quotation) => {
        if (!quotation) return;
        setToCancelQuotation(quotation.quotation_id);
        setShowModal(true);
    };

    const handleSendQuotation = async (id) => {
        if (!id) return;
        setLoading(true);
        try {
            const payload = {
                quotation_id: id,
                customer_id: customer_id,
                user_login_id: loginUserId,
            };

            const res = await PostRequest(
                `/quotation/sendQuotation`,
                payload,
                false,
                { headers },
                extras
            );

            if (res.status !== "success" || res.status === "fail") {
                return toast.error(res.message);
            }
            toast.success(res.message);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // Confirm delete and call API
    const handleConfirmedDelete = async () => {
        setLoading(true)
        try {
            // const item = allQuotation.find(
            //   (d) => d.quotation_id === departmentToDelete
            // );
            const res = await DeleteRequest(
                `quotation/deleteQuotation/${departmentToDelete}/${loginUserId}/${customer_id}`,
                { headers },
                extras
            );

            if (res?.status === "success") {
                toast.success(res.message);
                await fetchQuotation();
            } else if (res.status === "fail") {
                toast.error(res.message);
            }
        } catch (error) {
            console.error("Delete error:", error);
        } finally {
            setLoading(false);
            setShowDeleteModal(false);
            setDepartmentToDelete(null);
        }
    };

    const handleShareQuotation = async (quotation) => {
        if (!quotation?.quotation_id) {
            toast.error("Quotation not found!");
            return;
        }

        const quotationCustomerId =
            quotation?.customer_id || customer_id;

        await sharePdf(
            `${baseURL}quotation/downloadQuotation/${quotationCustomerId}/${quotation.quotation_id}`,
            headers,
            "download",
            loginUserId,
            setLoading,
            `quotation_${quotation.quotation_number}`
        );
    };



    const tableHeader = () => (<thead style={{ zIndex: "10" }}>
        <tr>
            <th>#</th>
            {columns?.map((col, index) => (
                <th key={`header-${index}`}>{col}</th>
            ))}
            {!isMyApproval && <th key="actions-header"></th>}
        </tr>
    </thead>
    )

    const tableBody = () => (dataToDisplay?.map((quotation, index) => (
        <tr key={quotation.quotation_id || index}>
            {/* Serial number cell */}
            <td>{limit * activeOffset + 1 + index}</td>

            {/* Dynamic cells based on columns order */}
            {columns?.map((col, cellIndex) => {
                // Map column labels to the actual data fields
                switch (col) {
                    case "Quotation Number":
                        return (
                            <td
                                key={`cell-${index}-${cellIndex}`}
                                className="text-primary"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                    navigateToCrmDetail(
                                        navigate,
                                        location,
                                        `/detailquotation/${quotation?.quotation_id}`,
                                        { key2: isMyApproval },
                                    )
                                }
                            >
                                {quotation.quotation_number || "N/A"}
                            </td>
                        );

                    case "Contact":
                        return (
                            <td
                                key={`cell-${index}-${cellIndex}`}
                                className="text-primary"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                    navigateToCrmDetail(
                                        navigate,
                                        location,
                                        `/detailquotation/${quotation?.quotation_id}`,
                                        { key2: isMyApproval },
                                    )
                                }
                            >
                                {quotation.contact_full_name || "N/A"}
                            </td>
                        );

                    case "Contact No":
                        return (
                            <td key={`cell-${index}-${cellIndex}`}>
                                <IconPhone size={14} stroke={2.5} style={{ color: 'blue' }} />
                                {/* {quotation.phone || "N/A"} */}
                                <span style={{ letterSpacing: "0.25px" }}>
                                    {maskContactNumber(customer, quotation.phone) || "N/A"}</span>
                            </td>
                        );

                    case "Company":
                        return (
                            <td key={`cell-${index}-${cellIndex}`}>
                                {quotation.company_name || "N/A"}
                            </td>
                        );

                    case "Quotation Date":
                        return (
                            <td key={`cell-${index}-${cellIndex}`}>
                                {formatDate(quotation.quotation_date) || "-"}
                            </td>
                        );

                    case "Expiry Date":
                        return (
                            <td key={`cell-${index}-${cellIndex}`}>
                                {quotation.expiry_date
                                    ? (() => {
                                        const today = new Date();
                                        const expiry = new Date(quotation.expiry_date);
                                        let bgColor = "";
                                        if (expiry < today) bgColor = "#f8d3d5";
                                        else if (expiry > today) bgColor = "#c0f7b8";
                                        else bgColor = "#f9f0ce";

                                        return (
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    backgroundColor: bgColor,
                                                    color: "#444040",
                                                    padding: "0px 6px",
                                                    borderRadius: "20px",
                                                    fontSize: "12px",
                                                    fontWeight: "400",
                                                }}
                                            >
                                                {formatDate(quotation.expiry_date)}
                                            </span>
                                        );
                                    })()
                                    : "-"}
                            </td>
                        );

                    case "Lead Owner":
                        return (
                            <td key={`cell-${index}-${cellIndex}`}>
                                {quotation.owner_full_name || "-"}
                            </td>
                        );

                    case "Deal":
                        return (
                            <td key={`cell-${index}-${cellIndex}`}>
                                {quotation.deal_name || "N/A"}
                            </td>
                        );

                    case "Quotation Status":
                        return (
                            <td
                                key={`cell-${index}-${cellIndex}`}
                                style={{
                                    textTransform: "capitalize",
                                    textAlign: "center",
                                }}
                            >
                                <span
                                    style={{
                                        textTransform: "capitalize",
                                        color:
                                            quotation.quotation_status === "pending"
                                                ? "#a28414"
                                                : quotation.quotation_status === "draft"
                                                    ? "#1f7a96"
                                                    : quotation.quotation_status === "cancel"
                                                        ? "#9e1920"
                                                        : quotation.quotation_status === "approved"
                                                            ? "#239b11"
                                                            : quotation.quotation_status === "reject"
                                                                ? "#4f575b"
                                                                : "#999",
                                        borderRadius: "12px",
                                        padding: "1.5px 6px",
                                        backgroundColor:
                                            quotation.quotation_status === "pending"
                                                ? "#f9f0ce"
                                                : quotation.quotation_status === "draft"
                                                    ? "#ceecf5"
                                                    : quotation.quotation_status === "cancel"
                                                        ? "#f8d3d5"
                                                        : quotation.quotation_status === "approved"
                                                            ? "#c0f7b8"
                                                            : quotation.quotation_status === "reject"
                                                                ? "#d2d6d8"
                                                                : "",
                                    }}
                                >
                                    {quotation.quotation_status || "N/A"}
                                </span>
                            </td>
                        );

                    default:
                        return <td key={`cell-${index}-${cellIndex}`}>-</td>;
                }
            })}

            {/* Actions column */}
            {!isMyApproval && (
                <td
                    key={`actions-${index}`}
                    className="lastactionTd"
                    style={{
                        "--pad": "14px",
                        paddingRight: "var(--pad) !important",
                        paddingLeft: "var(--pad) !important",
                        zIndex: openRow === quotation.quotation_id ? 11 : "auto",
                    }}
                >
                    <div className="endTdDiv">
                        <Dropdown
                            as="div"
                            className="dropdownsWithoutToggle"
                            onToggle={(isOpen) =>
                                setOpenRow(isOpen ? quotation.quotation_id : null)
                            }
                        >
                            <Dropdown.Toggle as={Nav.Link} className="header-link">
                                <FontAwesomeIcon
                                    className="text-muted"
                                    style={{
                                        width: "15px",
                                        height: "15px",
                                        color: "#536485",
                                    }}
                                    icon={faEllipsisVertical}
                                />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                align={"end"}
                                style={{
                                    width: "8rem",
                                    inset: "0px auto auto 0px",
                                    boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                    position: "absolute",
                                    marginTop: "-22px",
                                    marginRight: "25px",
                                    minWidth: "3rem",
                                }}
                            >
                                {/* Keep your existing dropdown items here */}
                                {quotation.quotation_status === "approved" ? (
                                    ""
                                ) : (
                                    <>
                                        <Dropdown.Item
                                            href="#"
                                            className="d-flex align-items-center"
                                            onClick={() => {
                                                if (!quotationGrant?.isEdit) {
                                                    toast.warning("You are not authorized for this action!");
                                                    return;
                                                }
                                                navigate(
                                                    `/editquotation/${quotation?.quotation_id}`,
                                                    {
                                                        state: { mode: "edit" }
                                                    }
                                                );
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faEdit}
                                                style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    marginRight: "9px",
                                                    color: "#5e5f60",
                                                }}
                                            />
                                            Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            href="#"
                                            className="d-flex align-items-center"
                                            onClick={() => {
                                                if (!quotationGrant?.isRevised) {
                                                    toast.warning(
                                                        "You are not authorized for this action!"
                                                    );
                                                    return;
                                                }
                                                navigate(
                                                    `/editquotation/${quotation?.quotation_id}`,
                                                    { state: { mode: "clone" } }
                                                );
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faClone}
                                                style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    marginRight: "9px",
                                                    color: "#5e5f60",
                                                }}
                                            />
                                            Revised
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            href="#"
                                            className="d-flex align-items-center"
                                            onClick={() => {
                                                if (!quotationGrant?.isCreate) {
                                                    toast.warning(
                                                        "You are not authorized for this action!"
                                                    );
                                                    return;
                                                }
                                                navigate(
                                                    `/editquotation/${quotation?.quotation_id}`,
                                                    { state: { mode: "cloneRe" } }
                                                );
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faClone}
                                                style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    marginRight: "9px",
                                                    color: "#5e5f60",
                                                }}
                                            />
                                            Clone
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            href="#"
                                            className="d-flex align-items-center"
                                            onClick={(e) => {
                                                e.preventDefault();

                                                if (!quotationGrant?.isExport) {
                                                    toast.warning(
                                                        "You are not authorized for this action!"
                                                    );
                                                    return;
                                                }

                                                handleShareQuotation(
                                                    quotation
                                                );
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faShare}
                                                style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    marginRight: "9px",
                                                    color: "#5e5f60",
                                                }}
                                            />
                                            Share
                                        </Dropdown.Item>

                                    </>
                                )}
                                <Dropdown.Item
                                    href="#"
                                    className="d-flex align-items-center"
                                    onClick={() => {
                                        if (!quotationGrant?.isDelete) {
                                            toast.warning(
                                                "You are not authorized for this action!"
                                            );
                                        }
                                        quotation.quotation_status === "approved"
                                            ? handleCancelQuotation(quotation)
                                            : onDelete(quotation.quotation_id);
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={
                                            quotation.quotation_status === "approved"
                                                ? faCancel
                                                : faTrash
                                        }
                                        style={{
                                            width: "16px",
                                            height: "16px",
                                            marginRight: "9px",
                                            color: "#5e5f60",
                                        }}
                                    />
                                    {quotation.quotation_status === "approved"
                                        ? "Cancel"
                                        : "Delete"}
                                </Dropdown.Item>
                                {quotation.quotation_status === "approved" && (
                                    // <Dropdown.Item
                                    //     href="#"
                                    //     className="d-flex align-items-center"
                                    //     onClick={() =>
                                    //         quotation.quotation_status === "approved" &&
                                    //         handleSendQuotation(quotation.quotation_id)
                                    //     }
                                    // >
                                    //     <FontAwesomeIcon
                                    //         icon={faMailForward}
                                    //         style={{
                                    //             width: "16px",
                                    //             height: "16px",
                                    //             marginRight: "9px",
                                    //             color: "#5e5f60",
                                    //         }}
                                    //     />
                                    //     {loading ? "Sending" : "Send Mail"}
                                    // </Dropdown.Item>
                                    <Dropdown.Item
                                        href="#"
                                        className="d-flex align-items-center"
                                        onClick={(e) => {
                                            e.preventDefault();

                                            if (!quotationGrant?.isExport) {
                                                toast.warning(
                                                    "You are not authorized for this action!"
                                                );
                                                return;
                                            }

                                            handleShareQuotation(
                                                quotation
                                            );
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faShare}
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginRight: "9px",
                                                color: "#5e5f60",
                                            }}
                                        />
                                        Share
                                    </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td>
            )}
        </tr>
    ))
    )

    return (
        <>
            {loading && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                        borderRadius: "inherit",
                    }}
                >
                    <div className="d-flex flex-column align-items-center">
                        <div
                            className="spinner-border text-primary"
                            role="status"
                            style={{ width: "3rem", height: "3rem" }}
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="mt-2 text-primary fw-semibold">sending mail</div>
                    </div>
                </div>
            )}

            <Container
                fluid
                style={{
                    fontFamily: "'Poppins', sans-serif",
                    height: "calc(100vh - 10rem)",
                    padding: 0,
                    animation: "cardEntry 1s ease-out forwards",
                }}
                className="mt-3 p-0"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        width: "100%",
                        borderRadius: "7px"
                    }}
                    className='position-relative container-table '
                >
                    <TableWrapper
                        isLoading={isLoading}
                        hasData={hasDataToDisplay}
                        tableHeader={tableHeader()}
                        tableBody={tableBody()}
                        displayStartItem={displayStartItem}
                        displayEndItem={displayEndItem}
                        totalItems={totalItems}
                        currPageItems={currPageItems}
                        offset={activeOffset}
                        setOffset={setActiveOffset}
                        limit={limit}
                        setLimit={setLimit}
                        handlePageChange={handlePageChange}
                        effectivePageCount={pageCount}
                        columnLabels={columns}
                    />


                </div>
                {showModal && (
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Cancel Quotation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <>
                                <p>Are you sure you want to cancel the quotation?</p>
                                <Form.Group controlId="rejectReason">
                                    <Form.Label>Reason</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={rejectReason}
                                        onChange={(e) => setRejectReason(e.target.value)}
                                    />
                                </Form.Group>
                            </>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                className="btn btn-default-outline me-2"
                                onClick={handleCloseModal}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn-default"
                                onClick={handleConfirm}
                                disabled={rejectReason.trim() === ""}
                            >
                                {loading ? "submiting.." : "Confirm"}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </Container >
            <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleConfirmedDelete}
                message="Are you sure you want to delete this item?"
                isLoading={loading}
            />
        </>
    )
}
